import keyMirror from 'keymirror';
export default keyMirror({
  SCHEMA_LOAD_SUCCESS: null,
  SCHEMA_LOAD_FAIL: null
});